/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type Store from "@ember-data/store";
import { action } from "@ember/object";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import type { BufferedChangeset } from "ember-changeset/types";
import { getGroupedBioExams } from "parog-web/components/bio-exam-results/utils/groupedBioExams";
import type BioExamOrder from "parog-web/models/bio-exam-order";
import type ErrorsService from "parog-web/services/errors";

import styles from "./index.module.css";

interface Args {
  changeset: BufferedChangeset;
}
export default class PrescriptionBioExamEditionFormContent extends Component<Args> {
  styles = styles;

  @service declare store: Store;
  @service declare errors: ErrorsService;

  declare prescriptibleOrders: BioExamOrder[];

  constructor(owner: unknown, args: Args) {
    super(owner, args);

    this.prescriptibleOrders = this.store.peekAll(
      "bio-exam-order"
    ) as unknown as BioExamOrder[];
  }

  get orderedPrescriptibleOrders() {
    return getGroupedBioExams(this.prescriptibleOrders);
  }

  get today() {
    return new Date();
  }

  get selectedFrequency(): string | undefined {
    const fqcy = this.args.changeset.get("frequency");
    return fqcy;
  }

  get frequencyOptions() {
    return [
      "1-day",
      "1-week",
      "2-week",
      "1-month",
      "2-month",
      "3-month",
      "4-month",
      "5-month",
      "6-month",
      "1-year",
      "none"
    ];
  }

  get validityOptions() {
    return [
      "Un mois",
      "Deux mois",
      "Trois mois",
      "Quatre mois",
      "Cinq mois",
      "Six mois",
      "Un an"
    ];
  }

  @action
  onOrderAdded(value: string) {
    const loincs = [...(this.args.changeset.get("exams") || [])];
    loincs.push(value);
    this.args.changeset.set("exams", loincs);
  }

  @action
  onOrderRemoved(value: string) {
    const loincs = [...(this.args.changeset.get("exams") as string[])];
    const indexToRemove = loincs.findIndex(loinc => loinc == value);
    loincs.splice(indexToRemove, 1);
    this.args.changeset.set("exams", loincs);
  }

  @action
  onFrequencyChanged(selectedValue: string) {
    const value = selectedValue;
    this.args.changeset.set("frequency", value);
  }

  @action
  updateAldRelatedComments(suggestion: string): void {
    this.appendComment("aldRelatedComments", suggestion);
  }

  @action
  updateNonAldRelatedComments(suggestion: string): void {
    this.appendComment("comments", suggestion);
  }

  labelFromLoinc = (loinc: string) => {
    return (this.store.peekRecord("bio-exam-order", loinc) as BioExamOrder)
      .longLabel;
  };

  appendComment(changesetKey: string, value: string): void {
    const comments = this.args.changeset.get(changesetKey) || "";
    const newComments = comments.concat(`${value}\n`);
    this.args.changeset.set(changesetKey, newComments);
  }
}
